import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Tag } from '@components/tag';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { TextArea } from '@components/textarea';
import { useToaster } from '@components/toaster';

import { useModel } from 'hooks/useModel';
import { useStore } from 'models/Provider';

import { RelesysSettings } from './Models';

export const RelesysSettingsPage = observer(() => {
  const { t, api } = useStore();
  const { showError, showSuccess } = useToaster();
  const model = useModel(RelesysSettings, {}, { api, showError, showSuccess, t });

  function onFocus() {
    if (model.clientSecret === '**********') {
      model.setClientSecret('');
    }
  }
  return (
    <Stack space={6}>
      <Stack space={1}>
        <Text font="heading2" text={t('integrations.relesys.settings.header')} />
        <Stack space={0} orientation="horizontal">
          {model.hasClientSecret && (
            <Tag
              size="small"
              variant="green"
              text={t('integrations.relesys.settings.header.clientsecret')}
            />
          )}
          {!model.hasClientSecret && (
            <Tag
              size="small"
              variant="purple"
              text={t('integrations.relesys.settings.header.noclientsecret')}
            />
          )}
        </Stack>
      </Stack>
      <Separator />
      <Stack space={4}>
        <Stack space={2}>
          <TextField
            label={t('integrations.relesys.settings.clientid.label')}
            onChange={model.setClientId}
            defaultValue={model.clientId}
          />
          <TextField
            label={t('integrations.relesys.settings.clientsecret.label')}
            onChange={model.setClientSecret}
            defaultValue={model.clientSecret}
            onFocus={onFocus}
          />
          <TextArea
            label={t('integrations.relesys.settings.smstext.label')}
            onChange={model.setSmsText}
            defaultValue={model.smsText}
          />
        </Stack>
        <Stack space={0} orientation="horizontal" justify="flex-end">
          <Button
            isDisabled={model.clientId.length === 0 || model.clientSecret.length === 0}
            onClick={model.submitSettings}
            text={t('integrations.relesys.settings.submit')}
          />
        </Stack>
      </Stack>
      <Stack space={4}>
        <Stack space={2}>
          <Text font="bold16" text={t('integrations.relesys.settings.instructions.header')} />
          <Text text={t('integrations.relesys.settings.instructions.content')} />
        </Stack>
        <Stack space={2}>
          <Text font="bold16" text={t('integrations.relesys.settings.gettingaccess.header')} />
          <Text text={t('integrations.relesys.settings.gettingaccess.content')} />
        </Stack>
        <Stack space={2}>
          <Text font="bold16" text={t('integrations.relesys.settings.howtoconnect.header')} />
          <Text text={t('integrations.relesys.settings.howtoconnect.content')} />
        </Stack>
      </Stack>
    </Stack>
  );
});
